export default __webpack_public_path__ + "static/media/node.bc4b43cd.jpg";